const dtGenerator = require("../../../../../components/dt/dt-generator");
const dtHandler = require("../../../../../components/dt/dt-handler");
const dtSearch = require("../../../../../components/dt/dt-search");
const dtReport = require("../../../../../components/dt/dt-report");
const accountsPayableMenu = require("./accountsPayable-menu");
const { organizeRow, tableDetail } = require("./accountsPayable-dt-handler");
const accountsPayableFetch = require("./accountsPayable-fetch");

/****************ELEMENTS*****************/
let htmlDt = {};
let HTMLwasSelected = false;
let allData = [];
let asc = false;

function HTMLselect() {
  dtHandler.HTMLselect("accountsPayable-dt", htmlDt, organizeRow, tableDetail);
  HTMLwasSelected = true;
}
/****************ELEMENTS*****************/

export function start(detail) {
  if (!HTMLwasSelected) HTMLselect();
  obj[detail.act]?.start(detail);
}

const obj = {
  addRow: {
    start: (detail) => dtGenerator.addRow(detail, htmlDt),
  },
  updateRow: {
    start: (detail) => dtGenerator.updateRow(detail, htmlDt),
  },
  tableOptions: {
    start: (detail) => accountsPayableMenu.start(detail, htmlDt, "htmlFc"),
  },
  trMenu: {
    start: (detail) => accountsPayableMenu.start(detail, htmlDt, "htmlFc"),
  },
  filter: {
    start: (detail) => dtSearch.filter(detail, htmlDt),
  },
  filterShowHide: {
    start: (detail) => dtSearch.filterShowHide(detail, htmlDt),
  },
  loadMore: {
    start: (detail) => dtSearch.loadMore(detail, htmlDt),
  },
  searching: {
    start: (detail) => dtSearch.searching(detail, htmlDt),
  },
  select: {
    start: (detail) => dtSearch.select(detail, htmlDt, true),
  },

  fecthData: {
    start: (detail) => fecthData(detail),
  },
  loadMoreRows: {
    start: (detail) => dtReport.loadMoreRows(allData, htmlDt, organizeRow),
  },
  sortBy: {
    start: (detail) => sortBy(detail, htmlDt),
  },
  searchValue: {
    start: (detail) => searchValue(detail, htmlDt),
  },
  filterBy: {
    start: (detail) => filterBy(detail, htmlDt),
  },
};

function fecthData(detail) {
  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayableAll",
  };

  accountsPayableFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) {
      return;
    }

    //se puede pasar otro para definir la cantidad de filas por pagina
    //ejemplo: dtReport.organizeRowDtReport(data, htmlDt, organizeRow, 10);
    dtReport.organizeRowDtReport(data, htmlDt, organizeRow);
    allData = data;
    fillColumns(data);
  });
}

function fillColumns(data) {
  const title = htmlDt.entityDt.querySelector(".title");
  const col1 = htmlDt.dtHeader.querySelector(".col-1");
  const col2 = htmlDt.dtHeader.querySelector(".col-2");
  const col3 = htmlDt.dtHeader.querySelector(".col-3");
  const col4 = htmlDt.dtHeader.querySelector(".col-4");
  const col5 = htmlDt.dtHeader.querySelector(".col-5");

  // Inicializar totales
  let current = 0;
  let total_30 = 0;
  let total_31_60 = 0;
  let total_61_90 = 0;
  let total_over_90 = 0;
  let total = 0;

  // Sumar todos los valores del parámetro
  data.forEach((element) => {
    current += parseFloat((element.current || "0").replace(/[^0-9.-]+/g, ""));
    total_30 += parseFloat(
      (element.total_due_30_days || "0").replace(/[^0-9.-]+/g, ""),
    );
    total_31_60 += parseFloat(
      (element.total_due_31_to_60_days || "0").replace(/[^0-9.-]+/g, ""),
    );
    total_61_90 += parseFloat(
      (element.total_due_61_to_90_days || "0").replace(/[^0-9.-]+/g, ""),
    );
    total_over_90 += parseFloat(
      (element.total_due_over_90_days || "0").replace(/[^0-9.-]+/g, ""),
    );
  });

  total = parseFloat(
    current + total_30 + total_31_60 + total_61_90 + total_over_90,
  );

  title.innerHTML = "Total: $" + total.toLocaleString();
  col1.innerHTML = "Current: $" + current.toLocaleString();
  col2.innerHTML = "$" + total_30.toLocaleString();
  col3.innerHTML = "$" + total_31_60.toLocaleString();
  col4.innerHTML = "$" + total_61_90.toLocaleString();
  col5.innerHTML = "$" + total_over_90.toLocaleString();

  const subTitles = [col1, col2, col3, col4, col5];

  subTitles.forEach((campo) => {
    campo.style.top = "auto";
    campo.style.fontSize = "14px";
  });
}

function sortBy(detail, htmlDt) {
  const sortBy = detail.sortBy;
  const sortOrder = asc ? "asc" : "desc";
  asc = !asc;

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayableAll",
    sort: {
      by: sortBy,
      dir: sortOrder,
    },
  };

  accountsPayableFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;

    dtReport.sortBy(data, htmlDt, organizeRow);
  });
}

function searchValue(detail, htmlDt) {
  const searchValue = detail.ev.target.value;

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayableAll",
    search: searchValue,
  };

  accountsPayableFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;
    dtReport.searchValue(data, htmlDt, organizeRow);
  });
}


let startDate = "";
let endDate = "";
function filterBy(detail, htmlDt) {
  const field = detail.field;
  const value = new Date(detail.ev.target.value);

  if (isNaN(value.getTime())) {
    fecthData(detail);
    return;
  }

  const isoDate = value.toISOString().split("T")[0];

  if (field === "start_date") {
    startDate = isoDate;
  } else if (field === "end_date") {
    endDate = isoDate;
  }

  const fetchDetail = {
    dest: "provider",
    elem: "report",
    reportType: "accountPayableAll",
    filterBy: {
      startDate: startDate,
      endDate: endDate || new Date().toISOString().split("T")[0],
    },
  };

  accountsPayableFetch.fetchAll(fetchDetail, (data) => {
    if (!Array.isArray(data) || data.length === 0) return;
    dtReport.filterBy(data, htmlDt, organizeRow);
  });
}
